import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'inbox-subscription-selector',
  imports: [CommonModule, GalaxyFormFieldModule, MatIconModule, MatChipsModule, TranslateModule],
  templateUrl: './subscription-selector.component.html',
  styleUrl: './subscription-selector.component.scss',
})
export class SubscriptionSelectorComponent {
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @Input() subscriptionLevels = <string[]>[];
  @Output() selectedSubscriptionLevels = new EventEmitter<string[]>();

  addSubscriptionLevel(event: MatChipInputEvent): void {
    if (event.value) {
      this.subscriptionLevels = [...this.subscriptionLevels, event.value];
      event.chipInput?.clear();
      this.selectedSubscriptionLevels.emit(this.subscriptionLevels);
    }
  }

  removeSubscriptionLevel(value: string): void {
    this.subscriptionLevels = this.subscriptionLevels.filter((level) => level !== value);
    this.selectedSubscriptionLevels.emit(this.subscriptionLevels);
  }
}
